import './OwnLayout.scss';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import Sidebar from './Sidebar';
import { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
const { Header: AntHeader, Sider, Content, Footer } = Layout;
const OwnLayout = ({ t }) => {
  const { darkMode } = useSelector((state) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const [scrollTop, setScrollTop] = useState(false);
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  // const dispatch = useDispatch();
  // swshs
  const CheckScrollTop = window.scrollY;
  useEffect(() => {
    if (CheckScrollTop > 10) {
      setScrollTop(true);
    } else {
      setScrollTop(false);
    }
  }, [CheckScrollTop]);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setVisible(false);
      } else {
        setVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className="min-layout"
      style={{
        background:
          'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
      }}
    >
      <Layout
        style={{
          background:
            'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
        }}
      >
        <div
          className="p-[1.5rem] lg:block hidden"
          style={{
            background: 'transparent',
          }}
        >
          <Sider
            width={240}
            breakpoint="lg"
            collapsed={collapsed}
            // collapsible
            onBreakpoint={(broken) => {
              console.log(broken);
            }}
            style={{
              overflow: 'auto',
              // height: scrollTop ? '100vh' : '95vh',
              height: '96vh',
              position: 'sticky',
              left: 0,
              top: 20,
              borderRadius: '16px',
              bottom: 0,
              backgroundColor: '#fff',
              // overflowY: 'hidden',
            }}
            onCollapse={(value) => setCollapsed(value)}
          >
            <div
              className=""
              style={{
                overflow: 'auto',
                height: '96vh',
                position: 'sticky',
                left: 0,
                top: 0,
                // top: scrollTop ? 0 : 20,
                bottom: 0,
                backgroundColor: '#fff',
              }}
            >
              <Sidebar collapsed={collapsed} />
            </div>
          </Sider>
        </div>
        <Layout
          className="site-layout py-[1.5rem] px-[10px] md:px-[30px] lg:px-[40px] xxl:px-[40px]  relative"
          style={{
            background:
              'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
          }}
        >
          <AntHeader
            className={`transition-all duration-150 ease-in-out`}
            style={{
              height: '70px',
              position: 'relative',
              top: 0,
              // top: 0,
              left: 0,
              zIndex: 1000,
              // padding:  '0 1.5rem 0 calc(1.5rem * .5)',
              borderRadius: '16px',
              padding: 0,
              background: 'transparent',
              // background: scrollTop ? '#fff' : 'transparent',

              // background:
              //   'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
            }}
          >
            <Header collapsed={collapsed} setCollapsed={setCollapsed} t={t} />
          </AntHeader>
          <Content
            className="py-[35px] overflow-hidden min-h-[87vh]"
            style={{
              background:
                'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
            }}
            // className="ml-[275px] py-0 px-[110px]"
          >
            <Outlet />
          </Content>
          <Footer
            style={{
              padding: '0px',
            }}
          ></Footer>
        </Layout>
      </Layout>
    </div>
  );
};

export default OwnLayout;
// import './OwnLayout.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import Header from './Header';
// import Sidebar from './Sidebar';
// import { useEffect, useState } from 'react';
// import { Layout } from 'antd';
// import { Outlet } from 'react-router-dom';
// const { Header: AntHeader, Sider, Content, Footer } = Layout;
// const OwnLayout = () => {
//   const { darkMode } = useSelector((state) => state.user);
//   const [collapsed, setCollapsed] = useState(false);
//   const [scrollTop, setScrollTop] = useState(false);
//   const [visible, setVisible] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   // const dispatch = useDispatch();
//   // swshs
//   const CheckScrollTop = window.scrollY;
//   useEffect(() => {
//     if (CheckScrollTop > 10) {
//       setScrollTop(true);
//     } else {
//       setScrollTop(false);
//     }
//   }, [CheckScrollTop]);
//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       if (currentScrollY > lastScrollY && currentScrollY > 50) {
//         setVisible(false);
//       } else {
//         setVisible(true);
//       }

//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [lastScrollY]);

//   return (
//     <div className="min-layout">
//       <Layout>
//         <div
//           className="p-[1.5rem] lg:block hidden"
//           // style={{
//           //   padding: '02.5rem',
//           // }}
//         >
//           <Sider
//             width={280}
//             breakpoint="lg"
//             collapsed={collapsed}
//             // collapsible
//             onBreakpoint={(broken) => {
//               console.log(broken);
//             }}
//             style={{
//               overflow: 'auto',
//               height: scrollTop ? '100vh' : '95vh',
//               position: 'sticky',
//               left: 0,
//               top: 0,
//               // top: scrollTop ? 0 : 20,
//               bottom: 0,
//               backgroundColor: darkMode ? '#303841' : '#fff',
//             }}
//             onCollapse={(value) => setCollapsed(value)}
//           >
//             <div
//               className=""
//               style={{
//                 overflow: 'auto',
//                 height: scrollTop ? '100vh' : '95vh',
//                 position: 'sticky',
//                 left: 0,
//                 top: 0,
//                 // top: scrollTop ? 0 : 20,
//                 bottom: 0,
//                 backgroundColor: darkMode ? '#303841' : '#fff',
//               }}
//             >
//               <Sidebar collapsed={collapsed} />
//             </div>
//           </Sider>
//         </div>
//         <Layout
//           // className="site-layout py-[1.5rem] px-[10px] md:px-[30px] lg:px-[50px] xxl:px-[100px] overflow-hidden relative"
//           className="site-layout py-[1.5rem] px-[10px] md:px-[30px] lg:px-[50px] xxl:px-[100px]  relative"
//         >
//           <AntHeader
//             className={`transition-all duration-150 ease-in-out`}
//             style={{
//               height: '70px',
//               position: 'sticky',
//               top: visible ? 0 : -70,
//               left: 0,
//               zIndex: 1000,
//               padding: '0 1.5rem 0 calc(1.5rem * .5)',
//               backgroundColor: darkMode ? '#303841' : '#fff',
//             }}
//           >
//             <Header collapsed={collapsed} setCollapsed={setCollapsed} />
//           </AntHeader>
//           <Content
//             className="min-h-[88vh]"
//             style={
//               {
//                 // marginLeft: '275px',
//               }
//             }
//             // className="ml-[275px] py-0 px-[110px]"
//           >
//             <Outlet />
//           </Content>
//           <Footer
//             style={{
//               padding: '0px',
//             }}
//           ></Footer>
//         </Layout>
//       </Layout>
//     </div>
//   );
// };

// export default OwnLayout;
